import { Checkbox, DatePicker, Descriptions } from 'antd';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import useNotification from '../../../hooks/useNotification';
import { ILanding } from '../../../models/landing.model';
import Button from '../../Button';
import Radio from '../../Radio';
import FileUpload from '../../FileUpload';
import CustomTimePicker from '../../CustomTimePicker';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';

export interface IProps {
  data?: ILanding;
  submit: (data: FormData) => void;
  mode: string;
}

const LandingPageEditor: FC<IProps> = ({ data, submit, mode = 'create' }) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // HP0010 학년 구분 
  const HP0010 = commonCodes.find((item) => item.commonCode === 'HP0010')?.detailCode;
  // HP0009 유입경로 구분
  const HP0009 = commonCodes.find((item) => item.commonCode === 'HP0009')?.detailCode;
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const campusList = campusData.filter(
    (item) =>
      item.campusKorName.includes('본사') === false &&
      item.campusKorName.includes('T') === false &&
      item.campusKorName.includes('시범') === false,
  );
  
  const { infoNotification } = useNotification();
  const [title, setTitle] = useState('');
  const [openYn, setOpenYn] = useState('N');
  
  const [campusCode, setCampusCode] = useState<any>([]);
  const [gradeCode, setGradeCode] = useState<any>([]);
  const [inflowCode, setInflowCode] = useState<any>([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [landingDesc, setLandingDesc] = useState('');
  const [landingLink, setLandingLink] = useState('');

  const [landingOgImageAttachFile, setLandingOgImageAttachFile] =
    useState<any>(null);
  const [component1PcAttachFile, setComponent1PcAttachFile] =
    useState<any>(null);
  const [component1MoAttachFile, setComponent1MoAttachFile] =
    useState<any>(null);
  const [component2PcAttachFile, setComponent2PcAttachFile] =
    useState<any>(null);
  const [component2MoAttachFile, setComponent2MoAttachFile] =
    useState<any>(null);
  const [landingLinkAttachFile, setLandingLinkAttachFile] =
    useState<any>(null);

  const [landingOgImageAttachFileCode, setLandingOgImageAttachFileCode] =
    useState<any>(null);
  const [component1PcAttachFileCode, setComponent1PcAttachFileCode] =
    useState<any>(null);
  const [component1MoAttachFileCode, setComponent1MoAttachFileCode] =
    useState<any>(null);
  const [component2PcAttachFileCode, setComponent2PcAttachFileCode] =
    useState<any>(null);
  const [component2MoAttachFileCode, setComponent2MoAttachFileCode] =
    useState<any>(null);
  const [landingLinkAttachFileCode, setLandingLinkAttachFileCode] =
    useState<any>(null);

  const { serverDate } = useSelector((state: RootState) => state.serverDate);

  useEffect(() => {

    if (data) {
      setTitle(data.title);
      setOpenYn(data.openYn);
      setStartDate(data.startDate);
      setEndDate(data.endDate);
      setStartTime(data.startTime);
      setEndTime(data.endTime);
      setLandingDesc(data.landingDesc);
      setLandingLink(data?.landingLink);
      setCampusCode(data?.campusCode?.split(','));
      setGradeCode(data?.gradeCode?.split(','));
      setInflowCode(data?.inflowCode?.split(','))

      if (data.landingOgImageAttachFile) {
        setLandingOgImageAttachFileCode(
          data.landingOgImageAttachFile.attachFileCode,
        );
      }

      if (data.component1PcAttachFile) {
        setComponent1PcAttachFileCode(
          data.component1PcAttachFile.attachFileCode,
        );
      }

      if (data.component1MoAttachFile) {
        setComponent1MoAttachFileCode(
          data.component1MoAttachFile.attachFileCode,
        );
      }

      if (data.component2PcAttachFile) {
        setComponent2PcAttachFileCode(
          data.component2PcAttachFile.attachFileCode,
        );
      }

      if (data.component2MoAttachFile) {
        setComponent2MoAttachFileCode(
          data.component2MoAttachFile.attachFileCode,
        );
      }

      if(data.landingLinkAttachFile) {
        setLandingLinkAttachFileCode(
          data.landingLinkAttachFile.attachFileCode,
        );
      }
    }
  }, [data]);

  useEffect(() => {
    if (serverDate) {
      setStartDate(moment(serverDate).format('YYYYMMDD'));
      setStartTime('00:00');
      setEndDate(moment(serverDate).add(1, 'days').format('YYYYMMDD'));
      setEndTime('00:00');
    }
  }, [serverDate]);

  const onCheckCampusList = (checked: boolean, value: string, e:any) => {
    let arrCampusCode: any = [];
    if (checked) {
      arrCampusCode = Array.isArray(campusCode) ? [...campusCode, value] : [...arrCampusCode, value];
    } else {
      arrCampusCode = campusCode?.filter((g: any) => g !== value) ?? [];
    }
    setCampusCode(arrCampusCode);
  }

  const onCheckGradeList = (checked: boolean, value: string, id: any, e:any) => {
    let arrGradeCode: any = [];
    if (checked) {
      arrGradeCode = Array.isArray(gradeCode) ? [...gradeCode, value] : [...arrGradeCode, value];
    } else {
      arrGradeCode = gradeCode?.filter((g: any) => g !== value) ?? [];
    }
    setGradeCode(arrGradeCode);
  }

  const onCheckInflowList = (checked: boolean, value: string, e:any) => {
    let arrInflowCode: any = [];
    if (checked) {
      arrInflowCode = Array.isArray(inflowCode) ? [...inflowCode, value] : [...arrInflowCode, value];
    } else {
      arrInflowCode = inflowCode?.filter((g: any) => g !== value) ?? [];
    }
    setInflowCode(arrInflowCode);
  };

  const onSubmit = () => {
    if (!title) {
      return infoNotification(t('landing.validate.text1'));
    }

    if (startDate + startTime > endDate + endTime) {
      return infoNotification(t('landing.validate.text3'));
    }

    if (campusCode.length < 1) {
      return infoNotification(t('landing.validate.text4'));
    }

    if (gradeCode.length < 1) {
      return infoNotification(t('landing.validate.text5'));
    }

    if (inflowCode.length < 1) {
      return infoNotification(t('landing.validate.text6'));
    }

    if (!component1PcAttachFile && mode !== 'edit') {
      return infoNotification(t('landing.validate.text2'));
    }

    if (!component1MoAttachFile && mode !== 'edit') {
      return infoNotification(t('landing.validate.text2'));
    }

    if (!component2PcAttachFile && mode !== 'edit') {
      return infoNotification(t('landing.validate.text2'));
    }

    if (!component2MoAttachFile && mode !== 'edit') {
      return infoNotification(t('landing.validate.text2'));
    }

    const form = new FormData();

    form.append('title', title);
    form.append('startDate', startDate);
    form.append('endDate', endDate);
    form.append('startTime', startTime);
    form.append('endTime', endTime);
    form.append('campusCode', campusCode?.join(','));
    form.append('gradeCode', gradeCode?.join(','));
    form.append('inflowCode', inflowCode?.join(','));
    form.append('openYn', openYn);
    form.append('landingDesc', landingDesc);
    form.append('landingLink', landingLink);

    if (landingOgImageAttachFile) {
      form.append('landingOgImageAttachFile', landingOgImageAttachFile);
    }

    if (component1PcAttachFile) {
      form.append('component1PcAttachFile', component1PcAttachFile);
    }

    if (component1MoAttachFile) {
      form.append('component1MoAttachFile', component1MoAttachFile);
    }

    if (component2PcAttachFile) {
      form.append('component2PcAttachFile', component2PcAttachFile);
    }

    if (component2MoAttachFile) {
      form.append('component2MoAttachFile', component2MoAttachFile);
    }

    if (landingLinkAttachFile) {
      form.append('landingLinkAttachFile', landingLinkAttachFile);
    }

    if (landingOgImageAttachFileCode) {
      form.append('landingOgImageAttachFileCode', landingOgImageAttachFileCode);
    }

    if (component1PcAttachFileCode) {
      form.append('component1PcAttachFileCode', component1PcAttachFileCode);
    }

    if (component1MoAttachFileCode) {
      form.append('component1MoAttachFileCode', component1MoAttachFileCode);
    }

    if (component2PcAttachFileCode) {
      form.append('component2PcAttachFileCode', component2PcAttachFileCode);
    }

    if (component2MoAttachFileCode) {
      form.append('component2MoAttachFileCode', component2MoAttachFileCode);
    }
    
    if (landingLinkAttachFileCode) {
      form.append('landingLinkAttachFileCode', landingLinkAttachFileCode);
    }
    

    if (mode === 'edit') {
      if (landingOgImageAttachFile && landingOgImageAttachFileCode) {
        form.append('landingOgImageAttachFileStatus', 'update');
      } else if (landingOgImageAttachFile && !landingOgImageAttachFileCode) {
        form.append('landingOgImageAttachFileStatus', 'create');
      }

      if (component1PcAttachFile && component1PcAttachFileCode) {
        form.append('component1PcAttachFileStatus', 'update');
      } else if (component1PcAttachFile && !component1PcAttachFileCode) {
        form.append('component1PcAttachFileStatus', 'create');
      }

      if (component1MoAttachFile && component1MoAttachFileCode) {
        form.append('component1MoAttachFileStatus', 'update');
      } else if (component1MoAttachFile && !component1MoAttachFileCode) {
        form.append('component1MoAttachFileStatus', 'create');
      }

      if (component2PcAttachFile && component2PcAttachFileCode) {
        form.append('component2PcAttachFileStatus', 'update');
      } else if (component2PcAttachFile && !component2PcAttachFileCode) {
        form.append('component2PcAttachFileStatus', 'create');
      }

      if (component2MoAttachFile && component2MoAttachFileCode) {
        form.append('component2MoAttachFileStatus', 'update');
      } else if (component2MoAttachFile && !component2MoAttachFileCode) {
        form.append('component2MoAttachFileStatus', 'create');
      }

      if (landingLinkAttachFile && landingLinkAttachFileCode) {
        form.append('landingLinkAttachFileStatus', 'update');
      } else if (landingLinkAttachFile && !landingLinkAttachFileCode) {
        form.append('landingLinkAttachFileStatus', 'create');
      }
    }
    // for (let key of form.entries()) {
    //   console.log(key);
    // }

    submit(form);
  };

  return (
    <>
      <div className='comm-table__area rowType'>
        <Descriptions bordered column={4} size="small">
          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column4')}`}
            span={4}
          >
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column9')}`}
            span={2}
          >
            <div className='comm-gap'>
              <div className="date-picker__area">
                <DatePicker
                  className="mr-1"
                  value={startDate ? moment(startDate) : undefined}
                  onChange={(e) => {
                    if (e === null) setStartDate('');
                    else setStartDate(moment(e).format('YYYYMMDD'));
                  }}
                />
              </div>
              <div className="time-picker__area">
                <CustomTimePicker
                  value={startTime}
                  onSelect={(value) => setStartTime(moment(value).format('HH:mm'))}
                  disabled={mode === 'read'}
                />
              </div>
            </div>
          </Descriptions.Item>

          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column10')}`}
            span={2}
          >
            <div className='comm-gap'>
              <div className="date-picker__area">
                <DatePicker
                  className="mr-1"
                  value={endDate ? moment(endDate) : undefined}
                  onChange={(e) => {
                    if (e === null) setEndDate('');
                    else setEndDate(moment(e).format('YYYYMMDD'));
                  }}
                />
              </div>
              <div className="time-picker__area">
                <CustomTimePicker
                  value={endTime}
                  onSelect={(value) => setEndTime(moment(value).format('HH:mm'))}
                  disabled={mode === 'read'}
                />
              </div>
            </div>
          </Descriptions.Item>

          {/* 캠퍼스 */}
          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column18')}`}
            span={4}
          >
            <span className='comm-gap'>
              {campusList?.map((item: any) => {
                return (
                  <Checkbox
                    className="campus"
                    key={item.campusCode}
                    value={item.campusCode}
                    checked={campusCode?.includes(item.campusCode)}
                    onChange={(e) =>
                      onCheckCampusList(e.target.checked, e.target.value, e)
                    }
                  >
                    {item.campusKorName} 캠퍼스
                  </Checkbox>
                );
              })}
            </span>
          </Descriptions.Item>

          {/* 학년 */}
          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column19')}`}
            span={4}
          >
            <span className='comm-gap'>
              {HP0010?.map((item: any) => {
                return (
                  <Checkbox
                    className="grade"
                    id={item.detailCode}
                    value={item.detailCode}
                    checked={gradeCode?.includes(item.detailCode)}
                    onChange={(e) =>
                      onCheckGradeList(e.target.checked, e.target.value, e.target.id, e)
                    }
                  >
                    {item.korName}
                  </Checkbox>
                );
              })}
            </span>
          </Descriptions.Item>

          {/* 유입경로 */}
          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column20')}`}
            span={4}
          >
            <span className='comm-gap'>
              {HP0009?.map((item: any) => {
                return (
                  <Checkbox
                    className="inflow"
                    key={item.detailCode}
                    value={item.detailCode}
                    checked={inflowCode?.includes(item.detailCode)}
                    onChange={(e) =>
                      onCheckInflowList(e.target.checked, e.target.value, e)
                    }
                  >
                    {item.korName}
                  </Checkbox>
                );
              })}
            </span>
          </Descriptions.Item>

          <Descriptions.Item
            label={`${t('landing.imagemanage.column8')}`}
            span={4}
          >
            <input
              type="text"
              className="form-control"
              value={landingDesc}
              onChange={(e) => setLandingDesc(e.target.value)}
            />
          </Descriptions.Item>

          <Descriptions.Item
            label={`${t('landing.imagemanage.column11')}`}
            span={4}
          >
            {data?.landingOgImageAttachFile && (
              <>
                <a
                  className="download-link"
                  href={data?.landingOgImageAttachFile?.fileLocation}
                  download={data?.landingOgImageAttachFile?.originalName}
                >
                  {data?.landingOgImageAttachFile?.originalName}
                </a>
                <br />
              </>
            )}
            <FileUpload
              file={landingOgImageAttachFile}
              setFile={setLandingOgImageAttachFile}
            />
          </Descriptions.Item>

          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column12')}`}
            span={2}
          >
            {data?.component1PcAttachFile && (
              <>
                <a
                  className="download-link"
                  href={data?.component1PcAttachFile?.fileLocation}
                  download={data?.component1PcAttachFile?.originalName}
                >
                  {data?.component1PcAttachFile?.originalName}
                </a>
                <br />
              </>
            )}
            <FileUpload
              file={component1PcAttachFile}
              setFile={setComponent1PcAttachFile}
            />
          </Descriptions.Item>
          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column13')}`}
            span={2}
          >
            {data?.component1MoAttachFile && (
              <>
                <a
                  className="download-link"
                  href={data?.component1MoAttachFile?.fileLocation}
                  download={data?.component1MoAttachFile?.originalName}
                >
                  {data?.component1MoAttachFile?.originalName}
                </a>
                <br />
              </>
            )}
            <FileUpload
              file={component1MoAttachFile}
              setFile={setComponent1MoAttachFile}
            />
          </Descriptions.Item>

          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column14')}`}
            span={2}
          >
            {data?.component2PcAttachFile && (
              <>
                <a
                  className="download-link"
                  href={data?.component2PcAttachFile?.fileLocation}
                  download={data?.component2PcAttachFile?.originalName}
                >
                  {data?.component2PcAttachFile?.originalName}
                </a>
                <br />
              </>
            )}
            <FileUpload
              file={component2PcAttachFile}
              setFile={setComponent2PcAttachFile}
            />
          </Descriptions.Item>
          <Descriptions.Item
            label={`* ${t('landing.imagemanage.column15')}`}
            span={2}
          >
            {data?.component2MoAttachFile && (
              <>
                <a
                  className="download-link"
                  href={data?.component2MoAttachFile?.fileLocation}
                  download={data?.component2MoAttachFile?.originalName}
                >
                  {data?.component2MoAttachFile?.originalName}
                </a>
                <br />
              </>
            )}
            <FileUpload
              file={component2MoAttachFile}
              setFile={setComponent2MoAttachFile}
            />
          </Descriptions.Item>

          <Descriptions.Item
            label={'추가 링크'}
            span={2}
          >
            <input
              type="text"
              className="form-control"
              value={landingLink}
              onChange={(e) => setLandingLink(e.target.value)}
            />
          </Descriptions.Item>

          <Descriptions.Item
            label={'추가 링크 이미지'}
            span={2}
          >
            {data?.landingLinkAttachFile && (
              <>
                <a
                  className="download-link"
                  href={data?.landingLinkAttachFile?.fileLocation}
                  download={data?.landingLinkAttachFile?.originalName}
                >
                  {data?.landingLinkAttachFile?.originalName}
                </a>
                <br />
              </>
            )}
            <FileUpload
              file={landingLinkAttachFile}
              setFile={setLandingLinkAttachFile}
            />
          </Descriptions.Item>

          <Descriptions.Item label={` ${t('landing.imagemanage.column16')}`}>
            <Radio
              checked={openYn === 'Y'}
              onChange={() => setOpenYn('Y')}
              text="Y"
            />
            <Radio
              className="ml-4"
              checked={openYn === 'N'}
              onChange={() => setOpenYn('N')}
              text="N"
            />
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className="btn-basic gray-line"
            onClick={() => history.push(`/landing/page${location.search}`)}
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            onClick={onSubmit}
            className="btn-basic pink"
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </>
  );
};

export default LandingPageEditor;
